import { combineReducers } from "redux";

import notification_reducer from "./notification";
import { user_reducer } from "./user";
import { item_reducer } from "./item";
import { customer_reducer } from "./customer";
import { order_reducer } from "./order";
import { reservation_reducer } from "./reservation";
import { rider_reducer } from "./rider";
import { company_reducer } from "./company";
import { plan_reducer } from "./plan";
import { work_reducer } from "./work";
import { worker_reducer } from "./worker";
import { party_reducer } from "./party";
import { deposit_reducer } from "./deposit";
import { tools_reducer } from "./tools";
import { account_reducer } from "./accounts";
import { dashboard_reducer } from "./dashboard";
import { vehicle_reducer } from "./vehicles";
import { yard_reducer } from "./yards";

export default combineReducers({
  notifications: notification_reducer,
  user: user_reducer,
  item: item_reducer,
  customer: customer_reducer,
  order: order_reducer,
  reservation: reservation_reducer,
  rider: rider_reducer,
  company: company_reducer,
  plan: plan_reducer,
  work: work_reducer,
  worker: worker_reducer,
  party: party_reducer,
  deposit: deposit_reducer,
  tools: tools_reducer,
  accounts: account_reducer,
  dashboard: dashboard_reducer,
  vehicles: vehicle_reducer,
  yards: yard_reducer,
});
